import { ALLERGIES } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";

import { createEnumTranslations } from "./createEnumTranslations";

export const useCatAllergies = () => {
  const tAllergens = useTranslations("Cats.Allergens");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: ALLERGIES.map(({ value }) => value),
    translate: (allergen) => tAllergens(snakeCaseToCamelCase(allergen)),
    fallback: unknown,
  });
};
